<template>
    <div class="category-icon">
        <svg v-if="selected" width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M57 57H0V0H57V57ZM1 56H20.998C11.2883 53.3574 3.64258 45.7117 1 36.002V56ZM56 36.002C53.3574 45.7117 45.7117 53.3574 36.002 56H56V36.002ZM29 23C26.2386 23 24 25.2386 24 28C24 30.7614 26.2386 33 29 33C31.7614 33 34 30.7614 34 28C34 25.2386 31.7614 23 29 23ZM1 20.9971C3.64281 11.2878 11.2886 3.6425 20.998 1H1V20.9971ZM36.002 1C45.7114 3.6425 53.3572 11.2878 56 20.9971V1H36.002Z"
                :fill="currentColor" />
        </svg>
        <svg v-else width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M57 0V57H0V0H57ZM56 36.002C53.3574 45.7117 45.7117 53.3574 36.002 56H56V36.002ZM1 56H20.998C11.2883 53.3574 3.64258 45.7117 1 36.002V56ZM28.5 1C13.3122 1 1 13.3122 1 28.5C1 43.6878 13.3122 56 28.5 56C43.6878 56 56 43.6878 56 28.5C56 13.3122 43.6878 1 28.5 1ZM33 28C33 25.7909 31.2091 24 29 24C26.7909 24 25 25.7909 25 28C25 30.2091 26.7909 32 29 32V33C26.2386 33 24 30.7614 24 28C24 25.2386 26.2386 23 29 23C31.7614 23 34 25.2386 34 28C34 30.7614 31.7614 33 29 33V32C31.2091 32 33 30.2091 33 28ZM1 20.9971C3.64281 11.2878 11.2886 3.6425 20.998 1H1V20.9971ZM36.002 1C45.7114 3.6425 53.3572 11.2878 56 20.9971V1H36.002Z"
                :fill="currentColor" />
        </svg>
        <div v-if="hasText" class="navbar-text-desc">
            <p>album artwork</p>
        </div>
    </div>
</template>

<style scoped>
.category-icon {
    width: v-bind(width);
    height: v-bind(height);
    display: flex;
    gap: 14px;
}

svg {
    height: v-bind(height);
}

.navbar-text-desc p {
    width: 40px;
}
</style>

<script setup>
import { useThemeStore } from '@/stores/useThemeStore';
import { computed } from 'vue';

const currentColor = computed(() => (useThemeStore.isDark ? "#E8E8E8" : "#000000"))

const props = defineProps({
    selected: {
        type: Boolean,
        default: false
    },
    hasText: {
        type: Boolean,
        default: false
    },
    width: {
        type: String,
        default: '153px'
    },
    height: {
        type: String,
        default: 'auto'
    }
})
</script>